import type { FaireProductEntity } from "../../entity_types/product";

export const p_dc7y49x3v4: FaireProductEntity = {
  token: "p_dc7y49x3v4",
  type: "product",
  name: "Calming Magnesium Oil",
  brandToken: "b_pt47qddvxc",
  brandName: "Mindful and Co Kids USA",
  imageUrl:
    "https://cdn.faire.com/fastly/cb9d76c9c5cf8a9236f06f573dbf774503bac724883dec967df092d4399b6267.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1cc8855304465131dd42e45f4bc7eaa4486d50a0cadbf49040cc2624f5a3888c.png",
    "https://cdn.faire.com/fastly/aae63b19f43affcea61727daa17260a49a94a33e99e625c32c80c333e7ced4fc.png",
    "https://cdn.faire.com/fastly/9438ad36a7bf357210bc8cb39a02ee93fe283573cd73ed0146b444736363f5b0.png",
    "https://cdn.faire.com/fastly/63c6be1202e2225fb3c5849194cf1f92fe1132060c8399eb1b9af8aefe4ef06a.png",
    "https://cdn.faire.com/fastly/e067f24e3cfa8158069735a65a2acd9664e03a30724fbf0c7bee6912c191d32c.png",
    "https://cdn.faire.com/fastly/bfa83f80ba295a9c5b6422de2cf1b9eeca2e2d43f1ae057c1232e7c76c1f001a.png",
    "https://cdn.faire.com/fastly/6513de0b32b166ce271f7b67f9f74227561fe77548d69245d841470e294ea4cd.png",
    "https://cdn.faire.com/fastly/d8d97d952afd9be1c7b34c55e6afe21376ed8fb8b62cf9a6808fa4cc02e80b6f.png",
  ],
  priceDollars: 17.5,
  description:
    "Unlock a peaceful sleep for little minds. \n\nElevate your child’s bedtime routine with our enchanting Magnesium Oil, sourced from the pristine depths of the Dead Sea. Immerse them in the tranquillity of this premium mineral, known to alleviate magnesium deficiency, soothe restless sleep, ease anxiety, tame growing pains, and enhance concentration.\n\nEnjoy by spraying directly onto the skin and gently massaging in, or pour 50ml into a bath or foot spa for a soothing 20 minute soak. Ideal for use both before and after exercise or as part of your bedtime routine.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:42.697Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
